const commonStore = {
  namespaced: true,
  state: {
    isCommentFlag: false,
    drawer: false,

  },
  mutations: {
    setCommentFlag (state, newValue) {
      state.isCommentFlag = newValue
    },
    setDrawer (state, newValue) {
      state.drawer = newValue
    },
  },
  actions: {

  },
  getters: {

  }
}
export default commonStore